import React from 'react';

const renderItem = ({ html_url, id, label }) => {
  if (!id) return null;
  if (!label) label = id;
  let Tag = (props) => <span {...props}/>;
  if (html_url) {
    Tag = ({ children, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" href={html_url}>{children}</a>;
  }

  return <Tag style={{ marginRight: '0.4rem' }} key={id}>{label}</Tag>;
};

const Services = ({ config = {} }) => {
  return <div> { (config.services || []).map(renderItem) } </div>;
};

export default Services;
